import { render, staticRenderFns } from "./AccessoriesOrderScore.vue?vue&type=template&id=1607f954&"
import script from "./AccessoriesOrderScore.vue?vue&type=script&lang=js&"
export * from "./AccessoriesOrderScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports